import { toast } from 'react-toastify'
const DEFAULT_SUCCESS_MESSAGE = 'Cálculos copiados com sucesso'
const DEFAULT_ERROR_MESSAGE = 'Erro ao copiar os cálculos'

export function copyResultsToClipboard({
  result,
  selector = '.results-section',
  removeButtons = true,
  removeSelectGroups = true,
  removeSvgParents = true,
  successMessage = DEFAULT_SUCCESS_MESSAGE,
  errorMessage = DEFAULT_ERROR_MESSAGE,
} = {}) {
  if (!result || result === '') return

  const element = document.querySelector(selector)
  if (!element) return

  const clone = element.cloneNode(true)

  if (removeButtons) {
    const button = clone.querySelector('button')
    if (button) {
      button.remove()
    }
  }

  if (removeSelectGroups) {
    const selects = clone.querySelectorAll('select')
    selects.forEach((select) => {
      let currentElement = select.parentElement
      while (currentElement && currentElement !== clone) {
        const hasSpan = currentElement.querySelector('p')
        const hasSelect = currentElement.querySelector('select')

        if (hasSpan && hasSelect && currentElement.children.length <= 3) {
          currentElement.remove()
          break
        }
        currentElement = currentElement.parentElement
      }
    })
  }

  if (removeSvgParents) {
    const svgs = clone.querySelectorAll('svg')
    svgs.forEach((svg) => {
      const svgParent = svg.parentElement
      if (svgParent) {
        svgParent.remove()
      }
    })
  }

  const htmlContent = clone.innerHTML

  const blob = new Blob([htmlContent], { type: 'text/html' })
  const clipboardItem = new ClipboardItem({ 'text/html': blob })

  navigator.clipboard
    .write([clipboardItem])
    .then(() => {
      toast.success(successMessage)
    })
    .catch((err) => {
      console.error('Erro ao copiar:', err)
      toast.error(errorMessage)
    })
}
